module.exports = __webpack_public_path__ + "static/media/fb_logo_icon.dc206b4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fb_logo_icon.svg
// module id = 518
// module chunks = 0